import React from 'react';

/**
 * "Masked user" icon (person with a masquerade mask) — lucide-compatible
 * props (className, strokeWidth, currentColor). Used for the Private
 * Profile menu entry, replacing the padlock (owner request, 14/07/2026).
 */
export const MaskedUserIcon = ({ className = '', strokeWidth = 2, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {/* head */}
    <circle cx="12" cy="7.5" r="5.1" />
    {/* shoulders / bust */}
    <path d="M4 20.5c0-3.4 3.6-6 8-6s8 2.6 8 6" />
    {/* masquerade mask (solid, with eye holes) */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      stroke="none"
      d="M8.15 5.9c1.15.62 2.45.93 3.85.93s2.7-.31 3.85-.93c.3 2.35-.95 4.15-2.3 4.15-.62 0-.95-.42-1.55-.42s-.93.42-1.55.42c-1.35 0-2.6-1.8-2.3-4.15Zm2.1 1.85c0 .38.4.68.9.68s.9-.3.9-.68-.4-.68-.9-.68-.9.3-.9.68Zm2.8 0c0 .38.4.68.9.68s.9-.3.9-.68-.4-.68-.9-.68-.9.3-.9.68Z"
    />
  </svg>
);

export default MaskedUserIcon;
